import React, { useEffect, useState } from "react";
import {
  CardHeadeWithActions,
  MwButton,
  MwInputFile,
  MwInputText,
  MwSelector,
  MwTextArea,
  NoDataFound,
  TagList,
  MwSpinnerButton,
  MwSpinner,
} from "../../../components/ui";
import {
  useCurrent,
  useFetch,
  usePost,
  usePut,
  useUploadFile,
} from "../../../hooks";
import { getDateNow } from "../../../utils/global";
import IncomesFormListItem from "./IncomesFormListItem";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import useConverter from "../../../hooks/useConverter";
import { useSelector } from "react-redux";
import i18next from "i18next";
import { NewButton } from "../../../components/ui/NewButton";
import { FaWindowClose } from "react-icons/fa";

const IncomesForm = ({ mode, setMode }) => {
  const params = useParams();
  const location = useLocation();
  const addDateParam = params?.date;
  const incomeId = params?.id;
  const hasValidIncomeId =
    Boolean(incomeId) && incomeId !== "null" && incomeId !== "undefined";
  const [t] = useTranslation("global");
  const [previewFile, setPreviewFile] = useState(null);
  const navigate = useNavigate();
  const [minEditDelayDone, setMinEditDelayDone] = useState(mode !== "Editing");
  const {
    currentTenantId,
    currentCompanyId,
    currentBranchId,
    userId,
    currentLangId,
  } = useCurrent();

  const sellerLabel = currentLangId === "ar" ? "المشتري" : t("Salaries.saler");
  const sellerPlaceholder =
    currentLangId === "ar" ? "المشتري..." : t("Bond.saler") + "...";

  const canFetchContext = Boolean(
    currentTenantId && currentCompanyId && currentBranchId
  );
  const [incomesTypes, setIncomesTypes] = useState([]);
  const { data: incomeData, loading: loadingIncome } = useFetch(
    mode === "Editing" && hasValidIncomeId
      ? `${process.env.REACT_APP_FINANCE_API_SERVER_BASE_URL}/incomes/${incomeId}`
      : null,
    { cache: false, persist: false }
  );

  const { data: incomesTypeResult, loading: loadingCountResult } = useFetch(
    canFetchContext
      ? `${process.env.REACT_APP_FINANCE_API_SERVER_BASE_URL}/incomes-types/${currentTenantId}/${currentCompanyId}/${currentBranchId}`
      : null
  );

  const { data: incomesTreasuriesResult, loading: loadingTreasuriesResult } =
    useFetch(
      canFetchContext
        ? `${process.env.REACT_APP_FINANCE_API_SERVER_BASE_URL}/treasuries/${currentTenantId}/${currentCompanyId}/${currentBranchId}`
        : null
    );
  const { data: customersResult } = useFetch(
    canFetchContext
      ? `${process.env.REACT_APP_Auth_API_BASE_URL}/customers/${currentTenantId}/${currentCompanyId}/${currentBranchId}`
      : null
  );
  const {
    data: taxtype,
    loading: loadingtaxtype,
    error: taxesError,
    refreshHandler: refreshTaxes,
  } = useFetch(
    canFetchContext
      ? `${process.env.REACT_APP_VAT_WEB_BASE_URL}/sales/taxes/${currentTenantId}/${currentCompanyId}/${currentBranchId}`
      : null,
    { cache: false, persist: false }
  );
  const {
    data: incomesPostResult,
    loading: loadingPostResult,
    postData,
    codeError,
  } = usePost();
  const { data, putData, loading: putloading } = usePut();
  const [showAttachPopup, setShowAttachPopup] = useState(false);
  const isLinkedInvoiceIncome =
    mode === "Editing" &&
    Boolean(incomeData?.data?.inv_id || incomeData?.data?.inv_no);
  const isReadOnlyView =
    new URLSearchParams(location.search).get("readonly") === "1";
  const isFormLocked = isLinkedInvoiceIncome || isReadOnlyView;

  const today = getDateNow().toLocaleDateString("en-CA");
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (mode !== "Editing") {
      setMinEditDelayDone(true);
      return;
    }
    setMinEditDelayDone(false);
    const timer = setTimeout(() => setMinEditDelayDone(true), 1200);
    return () => clearTimeout(timer);
  }, [mode, incomeId]);

  const [incomesFormItemsState, setIncomesFormItemsState] = useState();
  useEffect(() => {
    if (!incomesFormItemsState || incomesFormItemsState.length === 0) {
      setIncomesFormItemsState([
        {
          to_account_no: "",
          to_account_name: "",
          desc: "",
          amount: "",
          tax_type: "",
          to_cost_account_no: "",
        },
      ]);
    }
  }, [incomesFormItemsState]);

  const [incomesFormState, setIncomesFormState] = useState({
    code: "",
    total_amount: "",
    vat_amount: "",
    total_amount_with_vat: "",
    desc: "",
    attach: "",
    seller_name: "",
    customer_id_selected: "",
    customer_name: "",
    tags: [],
    treasury_id_selected: "",
    tax_type_selected: {},
    repeat_period: "",
    repeat_expire: "",
    incomes_date: today,
    incomes_type_id: "",
  });

  useEffect(() => {
    if (mode === "Editing") return;
    if (!addDateParam || !/^\d{4}-\d{2}-\d{2}$/.test(addDateParam)) return;
    setIncomesFormState((prev) =>
      prev.incomes_date === addDateParam
        ? prev
        : { ...prev, incomes_date: addDateParam }
    );
  }, [addDateParam, mode]);

  const formatYmd = (value) => {
    if (!value) return "";
    if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
      return value;
    }
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return "";
    return d.toISOString().split("T")[0];
  };

  const incomeDateForCode = formatYmd(incomesFormState.incomes_date) || today;
  const { data: incomesCountResult, loading: loadingincomesTypeResult } =
    useFetch(
      canFetchContext && mode !== "Editing"
        ? `${process.env.REACT_APP_FINANCE_API_SERVER_BASE_URL}/incomes/count/${currentTenantId}/${currentCompanyId}/${currentBranchId}/${encodeURIComponent(
            incomeDateForCode
          )}`
        : null,
      { cache: false, persist: false }
    );

  useEffect(() => {
    if (incomesTypeResult) {
      const _Types = incomesTypeResult.data.map((item) => ({
        label: currentLangId === "ar" ? item.name_ar : item.name_en,
        value: item.id,
        lang: currentLangId,
      }));
      setIncomesTypes(_Types);
    }
  }, [incomesTypeResult, currentLangId]);

  const [_taxTypeList, set_taxTypeList] = useState([]);

  useEffect(() => {
    if (taxtype) {
      // ===== FIX: فلتر الضرائب — في نموذج الإيرادات نعرض SALES و ALL فقط =====
      const filtered = taxtype.data.filter(
        (item) => item.tax_type === "SALES" || item.tax_type === "ALL"
      );
      const _list = filtered.map((item) => ({
        label: currentLangId === "ar"
          ? item.tax_name_ar?.trim()
          : item.tax_name_en?.trim(),
        id: item.id,
        value: item.tax_value,
        lang: currentLangId,
      }));
      set_taxTypeList(_list);
    }
  }, [taxtype, currentLangId]);

  // قائمة كاملة بدون فلتر — للـ matching وقت تحميل بيانات الفاتورة
  const _taxTypeListAll = taxtype?.data?.map((item) => ({
    label: currentLangId === "ar"
      ? item.tax_name_ar?.trim()
      : item.tax_name_en?.trim(),
    id: item.id,
    value: item.tax_value,
    lang: currentLangId,
  })) || [];

  const [treasuiesList, setTreasuiesList] = useState([]);
  const [treasuriesWithAccounts, setTreasuriesWithAccounts] = useState([]);
  const [customersList, setCustomersList] = useState([]);
  const allowTypes = "*";

  useEffect(() => {
    if (!customersResult?.data) return;
    const list =
      customersResult.data?.map((item) => {
        const nameObj = item.fullname?.find((n) => n.lang === currentLangId);
        return {
          label: nameObj?.text || item.fullname?.[0]?.text || "",
          value: String(item._id || "").trim(),
          lang: currentLangId,
        };
      }) || [];
    setCustomersList(list);
  }, [customersResult, currentLangId]);

  const {
    location: attachLocation,
    loading: loadingAttach,
    handleMultiUploads: handleUpload,
  } = useUploadFile(allowTypes, `incomes-${currentTenantId}`, "file");

  const { resultdelete, loadingDeleting, handleDelete } = useUploadFile();

  const addNewHandler = () => {
    const lastItem = incomesFormItemsState[incomesFormItemsState.length - 1];
    let error = {};

    if (!lastItem || !lastItem.amount) {
      if (!lastItem?.amount || isNaN(parseFloat(lastItem?.amount))) {
        error.amount = "Amount Is Required";
      }
    }

    if (Object.keys(error).length > 0) {
      setErrors(error);
      return;
    }

    setErrors({});
    setIncomesFormItemsState((prevState) => [
      ...prevState,
      {
        to_account_no: "",
        to_account_name: "",
        desc: "",
        amount: "",
        tax_type: "",
        to_cost_account_no: "",
      },
    ]);
  };

  useEffect(() => {
    if (incomesCountResult && mode !== "Editing") {
      const baseCode = Number.parseInt(incomesCountResult?.data, 10);
      const nextCode = Number.isFinite(baseCode) ? baseCode + 1 : 1;
      setIncomesFormState((prevState) => ({
        ...prevState,
        code: nextCode,
      }));
    }
  }, [incomesCountResult, mode]);

  useEffect(() => {
    if (incomesTreasuriesResult) {
      const _list = incomesTreasuriesResult.data.map((item) => ({
        label: currentLangId === "ar" ? item.name_ar : item.name_en,
        value: item.id,
        lang: currentLangId,
      }));
      setTreasuiesList(_list);

      const _treasuriesWithAccounts = incomesTreasuriesResult.data.map((item) => ({
        id: item.id,
        name_ar: item.name_ar,
        name_en: item.name_en,
        account_no: item.account_no,
      }));
      setTreasuriesWithAccounts(_treasuriesWithAccounts);
    }
  }, [incomesTreasuriesResult, currentLangId]);

  useEffect(() => {
    if (attachLocation) {
      setIncomesFormState((prev) => ({
        ...prev,
        attach: prev.attach
          ? `${prev.attach},${attachLocation}`
          : attachLocation,
      }));
    }
  }, [attachLocation]);

  useEffect(() => {
    if (!incomesFormItemsState?.length) return;

    const totalGrossAmount = incomesFormItemsState.reduce(
      (acc, item) => acc + (parseFloat(item.amount) || 0),
      0
    );

    const vatAmount = incomesFormItemsState.reduce((acc, item) => {
      const grossAmount = parseFloat(item?.amount) || 0;
      const taxPercent = Number(item?.tax_type?.value || 0);
      const itemVat =
        taxPercent > 0
          ? (grossAmount * taxPercent) / (100 + taxPercent)
          : 0;
      return acc + itemVat;
    }, 0);

    const totalAmount = totalGrossAmount - vatAmount;

    setIncomesFormState((prevState) => ({
      ...prevState,
      total_amount: totalAmount.toFixed(2),
      vat_amount: vatAmount.toFixed(2),
      total_amount_with_vat: totalGrossAmount.toFixed(2),
    }));
  }, [incomesFormItemsState]);

  useEffect(() => {
    setTimeout(() => {
      if (incomesPostResult && codeError === 1) {
        if (mode === "Editing" && hasValidIncomeId) {
          navigate(`/${params.tenant}/incomes/show/${incomeId}`);
        } else {
          navigate(`/${params.tenant}/incomes`);
        }
      }
    }, 300);
  }, [incomesPostResult, codeError, mode, hasValidIncomeId, incomeId, navigate, params.tenant]);

  const submitHandler = (e) => {
    e.preventDefault();
    if (mode === "Editing" && !hasValidIncomeId) {
      navigate(`/${params.tenant}/incomes`);
      return;
    }
    let errorObj = {};
    const lastIndex = incomesFormItemsState.length - 1;

    if (!incomesFormState?.treasury_id_selected) {
      errorObj = { ...errorObj, treasury: "treasury is required" };
    }
    if (!incomesFormItemsState[lastIndex]?.amount) {
      errorObj = { ...errorObj, amount: " Amount is required" };
    }
    if (incomesFormState.attach?.split(",").length > 5) {
      errorObj = { ...errorObj, attach: t("Salaries.NumberValidate") };
    }

    if (Object.keys(errorObj).length !== 0) {
      setErrors(errorObj);
      return;
    }

    const _dataPost = {
      code: incomesFormState.code,
      total_amount: parseFloat(incomesFormState?.total_amount || 0).toFixed(2),
      vat_amount: parseFloat(incomesFormState.vat_amount || 0).toFixed(2),
      total_amount_with_vat: parseFloat(
        incomesFormState.total_amount_with_vat || 0
      ).toFixed(2),
      desc: incomesFormState.desc || "",
      attach: incomesFormState.attach || "",
      seller_name:
        String(incomesFormState.seller_name || "").trim() ||
        String(
          incomesFormState.customer_name ||
            incomesFormState.customer_id_selected?.label ||
            ""
        ).trim(),
      customer_id: String(incomesFormState.customer_id_selected?.value || "").trim(),
      customer_name:
        incomesFormState.customer_name ||
        incomesFormState.customer_id_selected?.label ||
        "",
      tags: JSON.stringify(incomesFormState.tags),
      treasury_id: incomesFormState.treasury_id_selected?.value,
      tax_type: "",
      repeat_period: incomesFormState.repeat_period || 0,
      repeat_expire: incomesFormState.repeat_expire || "",
      incomes_date: incomesFormState.incomes_date,
      tenant_id: currentTenantId,
      company_id: currentCompanyId,
      branch_id: currentBranchId,
      created_by: userId,
      incomes_type_id: incomesFormState?.incomes_type_id?.value || "",
      details: incomesFormItemsState.map((item) => {
        const grossAmount = parseFloat(item.amount || 0);
        const taxPercent = Number(item?.tax_type?.value || 0);
        const vatPortion =
          taxPercent > 0 ? (grossAmount * taxPercent) / (100 + taxPercent) : 0;
        const netAmount = grossAmount - vatPortion;
        return {
          to_account_no: item?.to_account_no || "",
          desc: item.desc || "",
          amount: Number.isFinite(netAmount) ? netAmount.toFixed(2) : "0.00",
          tax_type: item?.tax_type?.id || item?.tax_type || "",
          to_cost_account_no: item?.to_cost_account_no || "",
        };
      }),
    };

    if (isLinkedInvoiceIncome) {
      _dataPost.inv_id = incomeData?.data?.inv_id;
      _dataPost.inv_no = incomeData?.data?.inv_no;
    }

    if (mode === "Editing") {
      const redirectAction = `incomes/show/${incomeId}`;
      putData(
        `${process.env.REACT_APP_FINANCE_API_SERVER_BASE_URL}/incomes/${incomeId}`,
        _dataPost,
        redirectAction
      );
    } else {
      postData(
        `${process.env.REACT_APP_FINANCE_API_SERVER_BASE_URL}/incomes`,
        _dataPost
      );
    }
  };

  useEffect(() => {
    if (incomeData) {
      const raw = incomeData?.data?.customer_id ?? incomeData?.data?.customer;
      const idRaw =
        raw && typeof raw === "object"
          ? raw?._id ?? raw?.id ?? raw?.value
          : raw;
      const id = String(idRaw || "").trim();
      const selectedCustomer =
        customersList.find((c) => String(c.value || "").trim() === id) ||
        (id
          ? {
              label: incomeData?.data?.customer_name || "",
              value: id,
              lang: currentLangId,
            }
          : "");
      const customerLabelFromData = String(
        incomeData?.data?.customer_name || selectedCustomer?.label || ""
      ).trim();
      const sellerName =
        String(incomeData?.data?.seller_name || "").trim() || customerLabelFromData;

      const rootTaxType = incomeData?.data?.tax_type;
      const rootTaxIdCandidate =
        rootTaxType?.id ??
        rootTaxType?._id ??
        (typeof rootTaxType === "string" || typeof rootTaxType === "number"
          ? String(rootTaxType)
          : "");

      // ===== FIX: استخدم القائمة الكاملة للـ matching عشان تلاقي أي ضريبة بصرف النظر عن نوعها =====
      const selectedRootTax =
        _taxTypeListAll.find((t) => String(t.id) === String(rootTaxIdCandidate)) ||
        {};

      setIncomesFormState({
        code: incomeData?.data?.code || incomesFormState.code,
        total_amount: incomeData?.data?.total_amount || "",
        vat_amount: incomeData?.data?.vat_amount || "",
        total_amount_with_vat: incomeData?.data?.total_amount_with_vat || "",
        desc: incomeData?.data?.desc || "",
        attach: incomeData?.data?.attach || "",
        seller_name: sellerName,
        customer_id_selected: selectedCustomer,
        customer_name: customerLabelFromData,
        tags: incomeData?.data?.tags ? JSON.parse(incomeData.data.tags) : [],
        incomes_type_id:
          incomesTypes.find(
            (t) => t.value === incomeData?.data?.incomes_type_id
          ) || "",
        treasury_id_selected:
          treasuiesList.find(
            (t) => t.value === incomeData?.data?.treasury_id
          ) || "",
        tax_type_selected: selectedRootTax,
        repeat_period: incomeData?.data?.repeat_period || "",
        repeat_expire: incomeData?.data?.repeat_expire || "",
        incomes_date: incomeData?.data?.incomes_date,
      });

      const detailsList = Array.isArray(incomeData?.data?.details)
        ? incomeData.data.details
        : [];
      const totalDetailsAmount = detailsList.reduce(
        (acc, item) => acc + Number(item?.amount || 0),
        0
      );
      const totalVatAmount = Number(incomeData?.data?.vat_amount || 0);

      setIncomesFormItemsState(
        detailsList.map((item) => {
          // ===== FIX: استخرج الـ tax id بشكل صحيح =====
          const rawTaxId =
            item?.tax_type?.id ??
            item?.tax_type?._id ??
            (typeof item?.tax_type === "string" || typeof item?.tax_type === "number"
              ? String(item.tax_type)
              : "");

          const taxIdCandidate = String(rawTaxId || "").trim() ||
            String(rootTaxIdCandidate || "").trim();

          const totalAmountNumber = Number(incomeData?.data?.total_amount || 0);
          const totalVatNumber = Number(incomeData?.data?.vat_amount || 0);
          const fallbackTaxPercent =
            totalAmountNumber > 0 && totalVatNumber > 0
              ? Number(((totalVatNumber / totalAmountNumber) * 100).toFixed(4))
              : 0;

          // ===== FIX: استخدم القائمة الكاملة للـ matching =====
          const matchedTax =
            _taxTypeListAll.find((t) => String(t.id) === taxIdCandidate) ||
            (selectedRootTax?.id ? selectedRootTax : null) ||
            _taxTypeListAll.find((t) => String(t.value) === String(fallbackTaxPercent)) ||
            "";

          const amountNumber = Number(item?.amount || 0);
          const directTaxAmount = item?.vat_amount ?? item?.tax_amount;
          const distributedTaxAmount =
            totalDetailsAmount > 0
              ? Number(
                  ((amountNumber / totalDetailsAmount) * totalVatAmount).toFixed(2)
                )
              : totalVatAmount;
          const taxAmountValue =
            directTaxAmount !== undefined &&
            directTaxAmount !== null &&
            String(directTaxAmount).trim() !== ""
              ? Number(directTaxAmount)
              : distributedTaxAmount;

          let toAccountNoValue = "";
          if (item.to_account_no) {
            if (typeof item.to_account_no === "object" && item.to_account_no.account_no) {
              toAccountNoValue = item.to_account_no.account_no;
            } else if (typeof item.to_account_no === "string") {
              toAccountNoValue = item.to_account_no;
            }
          }

          return {
            to_account_no: toAccountNoValue,
            desc: item.desc || "",
            amount: Number(
              (Number(item.amount || 0) + Number(taxAmountValue || 0)).toFixed(2)
            ).toString(),
            tax_type: matchedTax,
            tax_amount_value: Number.isFinite(taxAmountValue)
              ? taxAmountValue.toFixed(2)
              : "0.00",
            to_cost_account_no: item.to_cost_account_no || "",
          };
        }) || []
      );
    }
  }, [
    incomeData,
    treasuiesList,
    customersList,
    incomesTypes,
    _taxTypeListAll.length,
    currentLangId,
  ]);

  const { convertNumberToWords } = useConverter();
  const [totalAmountInWords, setTotalAmountInWords] = useState("");
  const language = useSelector((state) => state.lang.language);

  const managebonds = () => {
    navigate(`/${params.tenant}/incomes`);
  };

  useEffect(() => {
    setTotalAmountInWords(convertNumberToWords(incomesFormState.total_amount));
  }, [incomesFormState.total_amount, language]);

  const selectedTreasuryAccount = treasuriesWithAccounts.find(
    (t) => t.id === incomesFormState.treasury_id_selected?.value
  );

  return (
    <>
      {mode === "Editing" &&
      (!minEditDelayDone || loadingIncome || loadingtaxtype) ? (
        <div className="bg-white h-[60vh] flex items-center justify-center">
          <MwSpinner hightScreen={false} />
        </div>
      ) : taxesError && _taxTypeList.length === 0 ? (
        <div className="h-[70vh] w-full flex flex-col gap-3 justify-center items-center">
          <div className="text-[#261759]">
            {taxesError?.response?.data?.message || taxesError?.message}
          </div>
          <NewButton type="saveBtn" onClick={refreshTaxes}>
            إعادة المحاولة
          </NewButton>
        </div>
      ) : (
        <div className="p-4 flex flex-col gap-5 bg-white">
          <CardHeadeWithActions
            title={
              mode !== "Editing" ? (
                <p className="text-[#261759]">{t("Salaries.addBond")}</p>
              ) : (
                <p className="text-[#261759]">{t("Salaries.editBond")}</p>
              )
            }
          >
            <div className="flex gap-4 w-72 justify-end items-center">
              <NewButton type="main" onClick={managebonds}>
                <img
                  className="w-5"
                  src="/assets/icons/Vector(10).png"
                  alt="manage icon"
                />
                <p className="text-[13px] ms-1">{t("dropdown.manage")}</p>
              </NewButton>
              <NewButton
                onClick={submitHandler}
                disabled={
                  isReadOnlyView ||
                  incomesFormState.total_amount <= 0 ||
                  putloading ||
                  loadingPostResult
                }
                type="saveBtn"
              >
                {loadingPostResult || putloading ? (
                  <MwSpinnerButton />
                ) : (
                  <span>{t("dropdown.save")}</span>
                )}
              </NewButton>
            </div>
          </CardHeadeWithActions>

          <div className="bg-white p-0 flex flex-row gap-3 border-b border-gray-200">
            <div className="border-e pe-3 flex-1 flex flex-col gap-3">
              <div className="flex gap-2">
                <div className="w-40">
                  <MwInputText
                    classNameInput="border border-[#8D82B6] text-center border-opacity-55 outline-none"
                    label={t("Salaries.BondNumber")}
                    value={incomesFormState?.code}
                    disabled={isFormLocked}
                    onChange={(e) =>
                      setIncomesFormState({
                        ...incomesFormState,
                        code: e.target.value,
                      })
                    }
                    invalid={codeError === 0}
                    invalidMsg={codeError === 0 && t("Salaries.codeError")}
                  />
                </div>

                <div className="w-42">
                  <MwInputText
                    inputType="text"
                    disabled={true}
                    label={t("Salaries.BondAmount")}
                    classNameInput="border text-center border-[#8D82B6] border-opacity-55 text-[#261759] font-bold text-xl outline-none"
                    value={incomesFormState.total_amount}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^\d*\.?\d*$/.test(value)) {
                        setIncomesFormState({
                          ...incomesFormState,
                          total_amount: value,
                        });
                      }
                    }}
                  />
                </div>

                <div className="flex-1">
                  <MwSelector
                    label={t("Salaries.Treasury")}
                    initalValue={t("invoice.selectTreasury")}
                    invalid={!!errors?.treasury}
                    invalidMsg={errors?.treasury}
                    dataType={"labelValue"}
                    _data={treasuiesList}
                    withAddNew={false}
                    withSearch={false}
                    disabled={isFormLocked}
                    selectedItem={incomesFormState.treasury_id_selected}
                    setSelectedItem={(newValue) =>
                      setIncomesFormState({
                        ...incomesFormState,
                        treasury_id_selected: newValue,
                      })
                    }
                  />
                </div>

                <div className="flex-1">
                  <MwInputText
                    inputType="date"
                    classNameInput="border border-[#8D82B6] border-opacity-55 text-md text-[#261759] color-[red-800] outline-none"
                    label={t("Salaries.BondDate")}
                    value={incomesFormState.incomes_date}
                    disabled={isFormLocked}
                    onChange={(e) =>
                      setIncomesFormState({
                        ...incomesFormState,
                        incomes_date: e.target.value,
                      })
                    }
                  />
                </div>
              </div>

              <div className="flex-1">
                <MwTextArea
                  rows={4}
                  classNamePrivate="border bg-red border-[#8D82B6] border-opacity-55 min-h-32 outline-none"
                  label={t("Salaries.bondDescription")}
                  placeholder={t("Bond.desc") + "..."}
                  value={incomesFormState.desc}
                  disabled={isFormLocked}
                  onChange={(e) =>
                    setIncomesFormState({
                      ...incomesFormState,
                      desc: e.target.value,
                    })
                  }
                />
                {mode && (
                  <h2 className="text-[#261759] mb-2 font-bold flex flex-col w-full mt-3 justify-between items-start">
                    <span className="font-semibold text-[#261759]">
                      <span className="font-bold text-sm text-[#261759]">
                        {t("Salaries.total-arabic")} :
                      </span>
                      <div className="total-arab flex flex-col gap-1 mt-1 justify-end items-en">
                        <span className="text-sm font-semibold text-[#261759]">
                          {language === "ar"
                            ? totalAmountInWords
                            : convertNumberToWords(
                                incomesFormState.total_amount,
                                "ar"
                              )}
                          {" - "}
                          <span>فقط لا غير</span>
                        </span>
                        <span className="text-sm font-semibold text-[#261759]">
                          {language === "en"
                            ? totalAmountInWords
                            : convertNumberToWords(
                                incomesFormState.total_amount,
                                "en"
                              )}
                          {" , "}
                          <span>nothing more </span>
                        </span>
                      </div>
                    </span>
                  </h2>
                )}
              </div>
            </div>

            <div className="flex flex-col gap-3">
              <div className="w-80 text-[#261759]">
                <MwInputText
                  label={sellerLabel}
                  value={
                    String(incomesFormState.seller_name || "").trim()
                      ? incomesFormState.seller_name
                      : incomesFormState.customer_name ||
                        incomesFormState.customer_id_selected?.label ||
                        ""
                  }
                  classNameInput="border border-[#8D82B6] border-opacity-55 outline-none"
                  placeholder={sellerPlaceholder}
                  disabled={isFormLocked}
                  onChange={(e) =>
                    setIncomesFormState({
                      ...incomesFormState,
                      seller_name: e.target.value,
                    })
                  }
                />
              </div>

              <div className="w-80 text-[#261759]">
                <MwSelector
                  label={t("customers.customerName")}
                  initalValue={t("customers.customerName")}
                  dataType={"labelValue"}
                  _data={customersList}
                  withAddNew={false}
                  withSearch={true}
                  disabled={isFormLocked}
                  selectedItem={incomesFormState.customer_id_selected}
                  setSelectedItem={(newValue) => {
                    setIncomesFormState((prev) => {
                      const nextCustomerName = String(newValue?.label || "").trim();
                      const prevSeller = String(prev?.seller_name || "").trim();
                      const prevCustomer = String(prev?.customer_name || "").trim();
                      const shouldSyncSeller =
                        !prevSeller || prevSeller === prevCustomer;
                      return {
                        ...prev,
                        customer_id_selected: newValue,
                        customer_name: nextCustomerName,
                        seller_name: shouldSyncSeller
                          ? nextCustomerName
                          : prev.seller_name,
                      };
                    });
                  }}
                />
              </div>

              <div className="w-80 text-[#261759]">
                <TagList
                  withLabel={true}
                  label={t("Salaries.tags")}
                  classNamePrivate="border border-[#8D82B6] border-opacity-55 outline-none"
                  tagList={incomesFormState.tags}
                  disabled={isFormLocked}
                  setTagList={(newValue) =>
                    setIncomesFormState({
                      ...incomesFormState,
                      tags: newValue,
                    })
                  }
                />
              </div>

              <div className="w-80 text-[#261759]">
                <MwSelector
                  label={t("Salaries.incomeType")}
                  initalValue={t("Salaries.selectIncomeType")}
                  dataType={"labelValue"}
                  _data={incomesTypes}
                  withAddNew={false}
                  withSearch={false}
                  disabled={isFormLocked}
                  selectedItem={incomesFormState.incomes_type_id}
                  setSelectedItem={(newValue) =>
                    setIncomesFormState({
                      ...incomesFormState,
                      incomes_type_id: newValue,
                    })
                  }
                />
              </div>

              <div className="w-[330px] gap-2 items-center">
                {incomesFormState?.attach ? (
                  <div className="flex flex-wrap justify-start gap-4 mt-3">
                    {incomesFormState.attach.split(",").map((file, index) => {
                      const trimmedFile = file.trim();
                      const isImage = /\.(png|jpe?g|gif|webp|bmp|svg)$/i.test(trimmedFile);
                      return (
                        <div
                          key={index}
                          className="relative group border border-[#8D82B6] rounded-lg overflow-hidden shadow-md hover:shadow-lg transition-all w-24 h-24 flex items-center justify-center bg-gray-50"
                        >
                          {isImage ? (
                            <img
                              src={trimmedFile}
                              alt={`attachment-${index}`}
                              className="object-cover w-full h-full cursor-pointer group-hover:opacity-75 transition"
                              onClick={() => {
                                setPreviewFile(trimmedFile);
                                setShowAttachPopup(true);
                              }}
                            />
                          ) : (
                            <div
                              className="flex flex-col items-center justify-center gap-1 cursor-pointer w-full h-full bg-white"
                              onClick={() => {
                                setPreviewFile(trimmedFile);
                                setShowAttachPopup(true);
                              }}
                            >
                              <iframe
                                src={trimmedFile}
                                title="Preview PDF"
                                className="w-[80%] h-[60%] border-none pointer-events-none"
                              />
                              <p className="text-[10px] text-[#261759] font-semibold">PDF</p>
                            </div>
                          )}
                          {!isFormLocked && (
                            <button
                              onClick={(e) => {
                                e.stopPropagation();
                                const updatedFiles = incomesFormState.attach
                                  .split(",")
                                  .filter((_, i) => i !== index)
                                  .join(",");
                                setIncomesFormState((prev) => ({
                                  ...prev,
                                  attach: updatedFiles,
                                }));
                                handleDelete(trimmedFile);
                              }}
                              className="absolute top-1 right-1 bg-[#261759] text-white text-xs p-1.5 rounded-full opacity-0 group-hover:opacity-100 transition"
                              title="Delete file"
                            >
                              ✕
                            </button>
                          )}
                        </div>
                      );
                    })}
                  </div>
                ) : null}

                {showAttachPopup && previewFile && (
                  <div
                    className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-70 p-4"
                    onClick={() => setShowAttachPopup(false)}
                  >
                    <div
                      className="relative bg-white rounded-xl shadow-xl max-w-[90vw] max-h-[90vh] w-full overflow-hidden"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <button
                        onClick={() => setShowAttachPopup(false)}
                        className="absolute top-2 end-3 bg-[#261759] text-white rounded-full h-9 w-9 flex items-center justify-center text-xl z-50"
                      >
                        <FaWindowClose />
                      </button>
                      <div className="p-4 flex justify-center items-center max-h-[85vh] overflow-auto">
                        {/\.(png|jpe?g|gif|webp|bmp|svg)$/i.test(previewFile) ? (
                          <img
                            src={previewFile}
                            alt="Preview"
                            className="max-w-full max-h-[80vh] object-contain rounded-md"
                          />
                        ) : (
                          <iframe
                            src={previewFile}
                            title="Preview PDF"
                            className="w-[80vw] h-[80vh] border-none"
                          />
                        )}
                      </div>
                    </div>
                  </div>
                )}

                {!isFormLocked && (
                  <div className="mt-3">
                    <MwInputFile
                      isMultiple={true}
                      label={t("Salaries.sentFiels") + " :"}
                      loading={loadingAttach}
                      acceptTypes="*/*"
                      onChangeHandler={(newFiles) => {
                        handleUpload(newFiles);
                      }}
                    />
                  </div>
                )}

                {errors.attach && (
                  <div className="!text-red-500 text-sm mt-1 text-center">
                    {errors.attach}
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="bg-white rounded-2xl p-0">
            <div className="text-[#261759] font-bold mb-2 p-0">
              {t("Salaries.accounts")}
            </div>
            {incomesFormItemsState && (
              <div className="bg-white rounded-2xl p-0">
                {incomesFormItemsState.map((item, index) => (
                  <IncomesFormListItem
                    errors={errors}
                    index={index}
                    item={item}
                    key={index}
                    incomesFormItemsState={incomesFormItemsState}
                    setIncomesFormItemsState={setIncomesFormItemsState}
                    _taxTypeList={_taxTypeList}
                    treasuiesList={treasuiesList}
                    addNewHandler={addNewHandler}
                    isLinkedInvoiceIncome={isLinkedInvoiceIncome}
                    disabledAll={isReadOnlyView}
                    treasuryAccount={selectedTreasuryAccount}
                  />
                ))}
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default IncomesForm;
